import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { usePractice } from "@/pages/StaffApp";

const ROLES = [["practice_admin", "Organization administrator"], ["coordinator", "Staff (operations coordinator)"], ["template_approver", "Template approver"]];

export default function AddToOrgDialog({ user, onClose, onDone }) {
  const me = usePractice()?.me;
  const [orgs, setOrgs] = useState([]);
  const [tid, setTid] = useState("");
  const [role, setRole] = useState("coordinator");
  useEffect(() => { if (user) { api.get("/enterprise/organizations").then((r) => setOrgs(r.data)).catch(() => {}); } }, [user]);
  const have = new Set((user?.memberships || []).map((m) => m.tenant_id));
  const self = user && me && user.user_id === me.user_id;
  const save = async () => {
    try { await api.post(`/enterprise/members/${user.user_id}/memberships`, { tenant_id: tid, role }); toast.success("Access granted (audited)"); setTid(""); onDone(); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!user} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="ent-add-org-dialog">
        <DialogHeader><DialogTitle>Add {user?.name} to an organization</DialogTitle>
          <DialogDescription>Providers and regional directors are linked to provider records, so add them from that organization's Admin screen.</DialogDescription></DialogHeader>
        {self ? <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-3" data-testid="ent-add-self-note">Super Admins cannot give themselves access. Ask an administrator of that organization to add you.</p> : (
          <div className="space-y-3">
            <div><Label className="text-xs">Organization</Label><Select value={tid} onValueChange={setTid}><SelectTrigger data-testid="ent-add-org-select"><SelectValue placeholder="Choose organization" /></SelectTrigger>
              <SelectContent>{orgs.filter((o) => !have.has(o.id) && o.lifecycle === "active").map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}</SelectContent></Select></div>
            <div><Label className="text-xs">Role</Label><Select value={role} onValueChange={setRole}><SelectTrigger data-testid="ent-add-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>{ROLES.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select></div>
          </div>)}
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button>{!self && <Button className="btn-brand" disabled={!tid} onClick={save} data-testid="ent-add-org-save">Add</Button>}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
